<template>
  <BaseStepperDialog
    :dialogSettings="dialogSettings"
    :totalSteps="6"
    :isSaving="isSaving"
    @onStepsUpdate="handleStepUpdate"
    @onSave="handleSave"
    @onClose="handleClose"
  >
    <template v-slot>
      <div class="dialog__form container col-lg-6 col-sm-12 mt-6">
        <div v-show="currentStep === 1">
          <h2>What type of DBS check do you have?</h2>
          <p class="mb-0">Make sure the photo is clear</p>
          <RadioButton
            @select="handleRadioChange"
            :selected-value="dbsType"
            :options="typeOptions"
          />
        </div>
        <div v-show="currentStep === 2">
          <h2>What is your DBS certificate number?</h2>
          <p class="mb-0">
            This can usually be found on the top right of your certificate
          </p>
          <v-text-field placeholder="E.g 0012345678" class="mt-2" />
        </div>
        <div v-show="currentStep === 3">
          <h2>What is the registered person/body for your DBS check?</h2>
          <p class="mb-0">
            This can be found in the ‘Countersignatory Details’ section of the
            certificate
          </p>
          <v-text-field class="mt-2" />
        </div>
        <div v-show="currentStep === 4">
          <h2>What is your DBS date of issue?</h2>
          <p class="mb-0">
            This can usually be found on the top right of your certificate
          </p>
          <DatePicker label="" class="date-picker-wrapper--no-label" />
        </div>
        <div v-show="currentStep === 5">
          <h2>Are you on the DBS Check Update Service?</h2>
          <RadioButton
            @select="handleUpdateServiceChange"
            :selected-value="updateService"
            :options="updateServiceOptions"
            showGroupInRow
          />
        </div>
        <div v-show="currentStep === 6">
          <h2>Upload a photo of your {{ dbsType }}</h2>
          <!-- WIP will update component when api is available -->
          <UploadDocument :compliance="compliance" />
        </div>
      </div>
    </template>
  </BaseStepperDialog>
</template>

<script>
import BaseStepperDialog from "@/components/common/BaseStepperDialog";
import RadioButton from "@/components/common/RadioButton";
import { DBS_TYPES } from "@/constants/offers";
import { BOOLEAN_OPTIONS } from "@/constants/common";
import UploadDocument from "@/views/offers/components/compliances/forms/UploadDocument";
import DatePicker from "@/components/common/DatePicker";

export default {
  props: {
    dialogSettings: Object,
    compliance: Object
  },
  components: { BaseStepperDialog, RadioButton, UploadDocument, DatePicker },
  data() {
    return {
      currentStep: 1,
      typeOptions: DBS_TYPES,
      updateServiceOptions: BOOLEAN_OPTIONS,
      isSaving: false,
      dbsType: null,
      updateService: false
    };
  },
  methods: {
    handleRadioChange(selectedValue) {
      this.dbsType = selectedValue;
    },
    handleStepUpdate(currentStep) {
      this.currentStep = currentStep;
    },
    handleUpdateServiceChange(selectedValue) {
      this.updateService = selectedValue;
    },
    handleSave() {
      // WIP
      this.isSaving = true;
    },
    handleClose() {
      this.isSaving = false;
      this.currentStep = 1;
    }
  }
};
</script>
